import { useMemo } from 'react';
import { QUERY_STATE, useFetch } from '@tmapy/utils';
import { useDispatch, useSelector } from '@tmapy/redux';
import { actionUpdateLegendState } from '../actions';
const MATCH_EXPRESSION = /^\d+(?:,\d+)?$/;
const gerCorrectAGSLegendUrl = (url) => {
    let serviceUrl = url;
    let layerId = '';
    let pos = NaN;
    // kontrol, jestli se nejedna o WMS
    if (url.toUpperCase().indexOf('/WMSSERVER') > -1) {
        // zjisti pozici WMSSERVER v url a odstrani jej
        pos = url.toUpperCase().indexOf('/WMSSERVER');
        serviceUrl = url.slice(0, pos);
        // zjisti pozici ARCGIS v url a rozsiri o REST
        pos = serviceUrl.toUpperCase().indexOf('/ARCGIS/');
        const str = serviceUrl.slice(pos, pos + 8);
        serviceUrl = serviceUrl.replace(str, str + 'rest/');
    }
    // kontrola jestli neni sluzba na konkretni vrstvu /number
    else {
        const regexp = /\/\d+$/g;
        const myReg = regexp.exec(url);
        if (myReg) {
            const [retUrl] = url.split(myReg[0]);
            serviceUrl = retUrl;
            layerId = myReg[0].slice(1);
        }
    }
    return { serviceUrl, layerId };
};
const getAGSLegendUrl = (url, symbolSize) => {
    const { serviceUrl, layerId } = gerCorrectAGSLegendUrl(url);
    const size = symbolSize && MATCH_EXPRESSION.exec(symbolSize) ? symbolSize : 20;
    if (layerId) {
        return `${serviceUrl}/queryLegends?f=pjson&layers=show%3A${layerId}&size=${size}`;
    }
    else {
        return `${serviceUrl}/legend?f=pjson&size=${size}`;
    }
};
export const useAGSLegend = (layerId) => {
    const dispatch = useDispatch();
    const legends = useSelector((state) => state.legend);
    const cachedLegend = legends.find((legend) => legend.layerId === layerId)
        ?.items;
    const layerConfig = useSelector((state) => state.mapCore.layers).find((layer) => layer.id === layerId);
    const legend = layerConfig?.legend;
    const symbolSize = typeof legend !== 'boolean'
        ? Array.isArray(legend)
            ? undefined
            : legend?.symbolSize
        : undefined;
    const url = layerConfig?.sourceOptions.url;
    const { queryState, data } = useFetch(cachedLegend?.length ? null : getAGSLegendUrl(url, symbolSize));
    const legendData = useMemo(() => {
        const legendItems = [];
        if (queryState === QUERY_STATE.SUCCESS && !data.error) {
            data.layers?.map((layer) => layer.legend.map((legend) => legendItems.push({
                imgSrc: `data:image/png;base64,${legend.imageData}`,
                label: legend.label,
            })));
            dispatch(actionUpdateLegendState({ layerId, legendItems }));
        }
        return legendItems;
    }, [data, dispatch, layerId, queryState]);
    return cachedLegend?.length ? cachedLegend : legendData;
};
//# sourceMappingURL=useAGSLegend.js.map